import React from 'react';
import { PageHeader } from './components/PageHeader';

/**
 * Getting Started — página de bienvenida / landing del Design System.
 * Título + descripción (adaptados del "Getting Started" de Polaris a Atlas),
 * reutilizando el `PageHeader` del resto de las páginas.
 */
export const DSGettingStartedPage: React.FC = () => (
  <div className="px-10 py-12">
    <div className="mx-auto flex w-full max-w-[800px] flex-col gap-14">
      <PageHeader
        title="Getting Started"
        description="Atlas es el design system de los productos de Estudio Atlas. Si estás empezando con Atlas, acá vas a encontrar una lista de recursos y guías recomendadas para arrancar."
      />
    </div>
  </div>
);
